const alreadyJobScores = [
    { min: 0, max: 18, jobIndex: 0, score: -20 },
    { min: 18, max: 27, jobIndex: 0, score: 1 },
    { min: 27, max: 40, jobIndex: 0, score: 3 },
    { min: 40, max: 55, jobIndex: 0, score: 3 },
    { min: 55, max: 200, jobIndex: 0, score: 2 },

    { min: 0, max: 18, jobIndex: 1, score: -20 },
    { min: 18, max: 27, jobIndex: 1, score: -10 },
    { min: 27, max: 40, jobIndex: 1, score: -12 },
    { min: 40, max: 55, jobIndex: 1, score: -18 },
    { min: 55, max: 200, jobIndex: 1, score: -18 },

    { min: 0, max: 18, jobIndex: 2, score: -20 },
    { min: 18, max: 27, jobIndex: 2, score: 12 },
    { min: 27, max: 40, jobIndex: 2, score: 17 },
    { min: 40, max: 55, jobIndex: 2, score: 18 },
    { min: 55, max: 200, jobIndex: 2, score: 18 },

    { min: 0, max: 18, jobIndex: 3, score: -20 },
    { min: 18, max: 27, jobIndex: 3, score: 12 },
    { min: 27, max: 40, jobIndex: 3, score: 17 },
    { min: 40, max: 55, jobIndex: 3, score: 18 },
    { min: 55, max: 200, jobIndex: 3, score: 18 },

    { min: 0, max: 18, jobIndex: 4, score: -20 },
    { min: 18, max: 27, jobIndex: 4, score: 15 },
    { min: 27, max: 40, jobIndex: 4, score: 18 },
    { min: 40, max: 55, jobIndex: 4, score: 18 },
    { min: 55, max: 200, jobIndex: 4, score: 18 },

    { min: 0, max: 18, jobIndex: 5, score: -20 },
    { min: 18, max: 27, jobIndex: 5, score: 12 },
    { min: 27, max: 40, jobIndex: 5, score: 17 },
    { min: 40, max: 55, jobIndex: 5, score: 18 },
    { min: 55, max: 200, jobIndex: 5, score: 18 },

    { min: 0, max: 18, jobIndex: 6, score: 0 },
    { min: 18, max: 27, jobIndex: 6, score: 0 },
    { min: 27, max: 40, jobIndex: 6, score: 0 },
    { min: 40, max: 55, jobIndex: 6, score: 0 },
    { min: 55, max: 200, jobIndex: 6, score: 10 },

    { min: 0, max: 18, jobIndex: 7, score: -20 },
    { min: 18, max: 27, jobIndex: 7, score: -20 },
    { min: 27, max: 40, jobIndex: 7, score: -14 },
    { min: 40, max: 55, jobIndex: 7, score: -20 },
    { min: 55, max: 200, jobIndex: 7, score: -20 },

    { min: 0, max: 18, jobIndex: 8, score: -20 },
    { min: 18, max: 27, jobIndex: 8, score: 2 },
    { min: 27, max: 40, jobIndex: 8, score: 1 },
    { min: 40, max: 55, jobIndex: 8, score: 0 },
    { min: 55, max: 200, jobIndex: 8, score: 0 },

    { min: 0, max: 18, jobIndex: 9, score: -20 },
    { min: 18, max: 27, jobIndex: 9, score: 10 },
    { min: 27, max: 40, jobIndex: 9, score: 17 },
    { min: 40, max: 55, jobIndex: 9, score: 18 },
    { min: 55, max: 200, jobIndex: 9, score: 18 },

    { min: 0, max: 18, jobIndex: 10, score: -20 },
    { min: 18, max: 27, jobIndex: 10, score: 12 },
    { min: 27, max: 40, jobIndex: 10, score: 17 },
    { min: 40, max: 55, jobIndex: 10, score: 18 },
    { min: 55, max: 200, jobIndex: 10, score: 18 },

    { min: 0, max: 18, jobIndex: 11, score: -20 },
    { min: 18, max: 27, jobIndex: 11, score: 12 },
    { min: 27, max: 40, jobIndex: 11, score: 17 },
    { min: 40, max: 55, jobIndex: 11, score: 18 },
    { min: 55, max: 200, jobIndex: 11, score: 18 },

    { min: 0, max: 18, jobIndex: 12, score: -20 },
    { min: 18, max: 27, jobIndex: 12, score: 8 },
    { min: 27, max: 40, jobIndex: 12, score: 10 },
    { min: 40, max: 55, jobIndex: 12, score: 12 },
    { min: 55, max: 200, jobIndex: 12, score: 12 },

    { min: 0, max: 18, jobIndex: 13, score: -20 },
    { min: 18, max: 27, jobIndex: 13, score: 2 },
    { min: 27, max: 40, jobIndex: 13, score: 3 },
    { min: 40, max: 55, jobIndex: 13, score: 4 },
    { min: 55, max: 200, jobIndex: 13, score: 4 }
];

export default alreadyJobScores;
